/**
 * FuturEnergy – Logo Component
 *
 * Usa le immagini PNG estratte direttamente dal PDF ufficiale
 * "FuturEnergy-BrandingManual.pdf" tramite pdfimages (144dpi).
 *
 * Sorgenti in /public/brand/:
 *   - logo-positive.png  → pagina 20 del manuale (uso reale, sfondo bianco)
 *   - logo-variant-b.png → pagina 22 (variante con alpha, per sfondi scuri)
 *   - logo-variant-a.png → pagina 22 (variante monocromatica)
 */

import React from 'react';

type LogoVariant = 'positive' | 'negative' | 'mono';
type LogoSize    = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;

interface FuturEnergyLogoProps {
  variant?:   LogoVariant;
  /** Larghezza in px oppure preset: xs=80 sm=140 md=200 lg=280 xl=400 */
  size?:      LogoSize;
  className?: string;
  style?:     React.CSSProperties;
}

const SIZE_MAP: Record<string, number> = {
  xs:  80,
  sm: 140,
  md: 200,
  lg: 280,
  xl: 400,
};

const VARIANT_SRC: Record<LogoVariant, string> = {
  positive: '/brand/logo-p05-hires.png',
  negative: '/brand/logo-p05-hires.png',
  mono:     '/brand/logo-p05-hires.png',
};

export const FuturEnergyLogo: React.FC<FuturEnergyLogoProps> = ({
  variant   = 'positive',
  size      = 'md',
  className,
  style,
}) => {
  const width = typeof size === 'number' ? size : (SIZE_MAP[size] ?? 200);

  return (
    <img
      src={VARIANT_SRC[variant]}
      alt="FuturEnergy"
      width={width}
      draggable={false}
      className={className}
      style={{
        display:    'block',
        height:     'auto',
        maxWidth:   '100%',
        userSelect: 'none',
        ...style,
      }}
    />
  );
};

export default FuturEnergyLogo;
